import { useAppSelector } from '../../app/hooks';
import { selectFormContext, selectFormSchema } from '../../app/slices/form.slice';
import styles from '../../assets/css/form.module.css';
import { Form } from '../../fxfs';
import { FormContext } from './FormContext';
import { SubmitButton } from './SubmitButton';
import { useForm } from './useForm';
import { Box } from '@mui/material';

const FormStep = () => {
	const schema = useAppSelector(selectFormSchema)!;
	const context = useAppSelector(selectFormContext)!;

	const { onChange, onValidationChange, onSubmit, submitting, isSubmitDisabled } = useForm(schema);

	return (
		<Box id="form-step" key={schema.form_identifier} className={`form-container ${styles['form-container']}`}>
			<FormContext context={context} />
			<Form form={schema} onChange={onChange} onValidationChange={onValidationChange} />
			<SubmitButton onSubmit={onSubmit} submitting={submitting} disabled={isSubmitDisabled} />
		</Box>
	);
};

export default FormStep;
